export const summary = (state: any) => {
    return state.summary;
}
export const isFetchingSummary = (state: any) => {
    return state.isFetchingSummary;
}
export const summaryError = (state: any) => {
    return state.summaryError;
}
